webpackJsonp([68915827593439],{

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _Spacing = __webpack_require__(8);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  hero: _propTypes2['default'].bool,
	  spacing: _propTypes2['default'].number,
	  spacingBottom: _propTypes2['default'].number,
	  spacingTop: _propTypes2['default'].number
	}));
	
	var defaultProps = {
	  hero: false,
	  spacing: 2,
	  spacingBottom: _Spacing.defaultProps.bottom,
	  spacingTop: _Spacing.defaultProps.top
	};
	
	function Rule(_ref) {
	  var css = _ref.css,
	      spacingBottom = _ref.spacingBottom,
	      spacingTop = _ref.spacingTop,
	      spacing = _ref.spacing,
	      hero = _ref.hero,
	      styles = _ref.styles;
	
	  return _react2['default'].createElement(
	    _Spacing2['default'],
	    {
	      bottom: spacingBottom,
	      top: spacingTop,
	      vertical: spacing
	    },
	    _react2['default'].createElement('div', css(styles.rule, hero && styles.hero))
	  );
	}
	
	Rule.componentCategory = 'Core';
	Rule.displayName = 'Rule';
	Rule.propTypes = propTypes;
	Rule.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var unit = _ref2.unit,
	      color = _ref2.color;
	  return {
	    rule: {
	      borderBottom: '1px solid ' + String(color.divider)
	    },
	
	    hero: {
	      width: 6 * unit
	    }
	  };
	}, { pureComponent: true })(Rule);

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(67);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Link = __webpack_require__(74);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Labeled = __webpack_require__(27);
	
	var _Labeled2 = _interopRequireDefault(_Labeled);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Using Gatsby's link component allows us to benefit from the Gatsby-specific
	// improvements it makes over react-router's link. This component is a fusion of
	// Gatsby Link and DLS styles. We also maintain the DLS prop API (meaning we use
	// "href" over "to")
	
	var propTypes = _extends({}, _withStyles.withStylesPropTypes, {
	  children: _propTypes2['default'].node.isRequired,
	  href: _propTypes2['default'].string,
	  navigation: _propTypes2['default'].bool,
	  footer: _propTypes2['default'].bool,
	  beforeIcon: _propTypes2['default'].node,
	  afterIcon: _propTypes2['default'].node,
	  onPress: _propTypes2['default'].func
	});
	
	var defaultProps = {
	  href: null,
	  navigation: false,
	  footer: false,
	  beforeIcon: null,
	  afterIcon: null,
	  onPress: function () {
	    function onPress() {}
	
	    return onPress;
	  }()
	};
	
	function Link(props) {
	  var children = props.children,
	      href = props.href,
	      styles = props.styles,
	      navigation = props.navigation,
	      footer = props.footer,
	      beforeIcon = props.beforeIcon,
	      afterIcon = props.afterIcon,
	      onPress = props.onPress;
	
	  // If the link is to an external link, use the regular DLS Link
	  // component. GatsbyLink only works with internal links
	
	  if (href.includes('http') || href.includes('https')) {
	    return _react2['default'].createElement(
	      _Link2['default'],
	      props,
	      children
	    );
	  }
	
	  var inner = void 0;
	
	  if (beforeIcon) {
	    inner = _react2['default'].createElement(
	      _Labeled2['default'],
	      { before: beforeIcon },
	      children
	    );
	  } else if (afterIcon) {
	    inner = _react2['default'].createElement(
	      _Labeled2['default'],
	      { after: afterIcon },
	      children
	    );
	  } else {
	    inner = children;
	  }
	
	  return _react2['default'].createElement(
	    _gatsbyLink2['default'],
	    _extends({
	      to: href,
	      onClick: onPress
	    }, (0, _withStyles.css)(styles.component, navigation && styles.navigation, footer && styles.footer)),
	    inner
	  );
	}
	
	Link.propTypes = propTypes;
	Link.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref) {
	  var font = _ref.font,
	      color = _ref.color;
	  return {
	    component: {
	      color: color.textLink,
	      font: 'inherit',
	      fontFamily: font.FONT_FAMILY,
	      textDecoration: 'none',
	
	      ':hover': {
	        textDecoration: 'underline'
	      },
	
	      ':active': {
	        color: color.textLinkActive
	      }
	    },
	
	    navigation: {
	      color: color.textDark
	    },
	
	    footer: {
	      color: color.textMuted
	    }
	  };
	})(Link);
	module.exports = exports['default'];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Rule = __webpack_require__(55);
	
	var _Rule2 = _interopRequireDefault(_Rule);
	
	var _Spacing = __webpack_require__(8);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _Title = __webpack_require__(39);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Text = __webpack_require__(16);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _HeadingSection = __webpack_require__(54);
	
	var _HeadingSection2 = _interopRequireDefault(_HeadingSection);
	
	var _Link = __webpack_require__(58);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CodeOfConductPage = function (_React$PureComponent) {
	  _inherits(CodeOfConductPage, _React$PureComponent);
	
	  function CodeOfConductPage() {
	    _classCallCheck(this, CodeOfConductPage);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  CodeOfConductPage.prototype.render = function () {
	    function render() {
	      return _react2['default'].createElement(
	        _Text2['default'],
	        { light: true },
	        _react2['default'].createElement(
	          'div',
	          { style: { maxWidth: '40em', margin: '0 auto' } },
	          _react2['default'].createElement(
	            _Spacing2['default'],
	            { top: 5 },
	            _react2['default'].createElement(
	              _HeadingSection2['default'],
	              null,
	              _react2['default'].createElement(
	                _Title2['default'],
	                { level: 1 },
	                'Open Source Code of\xA0Conduct'
	              ),
	              _react2['default'].createElement(_Rule2['default'], null),
	              _react2['default'].createElement(
	                _HeadingSection2['default'],
	                null,
	                _react2['default'].createElement(
	                  _Title2['default'],
	                  { level: 2 },
	                  'Our Pledge'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'We as members, contributors, and leaders pledge to make participation in our community a harassment-free experience for everyone, regardless of age, body size, visible or invisible disability, ethnicity, sex characteristics, gender identity and expression, level of experience, education, socio-economic status, nationality, personal appearance, race, religion, or sexual identity and orientation.'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'We pledge to act and interact in ways that contribute to an open, welcoming, diverse, inclusive, and healthy community.'
	                )
	              ),
	              _react2['default'].createElement(
	                _HeadingSection2['default'],
	                null,
	                _react2['default'].createElement(
	                  _Title2['default'],
	                  { level: 2 },
	                  'Our Standards'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'Examples of behavior that contributes to a positive environment for our community include:'
	                ),
	                _react2['default'].createElement(
	                  'ul',
	                  null,
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Demonstrating empathy and kindness toward other people'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Being respectful of differing opinions, viewpoints, and experiences'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Giving and gracefully accepting constructive feedback'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Accepting responsibility and apologizing to those affected by our mistakes, and learning from the experience'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Focusing on what is best not just for us as individuals, but for the overall community'
	                  )
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'Examples of unacceptable behavior include:'
	                ),
	                _react2['default'].createElement(
	                  'ul',
	                  null,
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'The use of sexualized language or imagery, and sexual attention or advances of any kind'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Trolling, insulting or derogatory comments, and personal or political attacks'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Public or private harassment'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Publishing others\u2019 private information, such as a physical or email address, without their explicit permission'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    'Other conduct which could reasonably be considered inappropriate in a professional setting'
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                _HeadingSection2['default'],
	                null,
	                _react2['default'].createElement(
	                  _Title2['default'],
	                  { level: 2 },
	                  'Enforcement Responsibilities'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'Community leaders are responsible for clarifying and enforcing our standards of acceptable behavior and will take appropriate and fair corrective action in response to any behavior that they deem inappropriate, threatening, offensive, or harmful.'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'Community leaders have the right and responsibility to remove, edit, or reject comments, commits, code, wiki edits, issues, and other contributions that are not aligned to this Code of Conduct, and will communicate reasons for moderation decisions when appropriate.'
	                )
	              ),
	              _react2['default'].createElement(
	                _HeadingSection2['default'],
	                null,
	                _react2['default'].createElement(
	                  _Title2['default'],
	                  { level: 2 },
	                  'Scope'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'This Code of Conduct applies within all community spaces, and also applies when an individual is officially representing the community in public spaces. Examples of representing our community include using an official email address, posting via an official social media account, or acting as an appointed representative at an online or offline event.'
	                )
	              ),
	              _react2['default'].createElement(
	                _HeadingSection2['default'],
	                null,
	                _react2['default'].createElement(
	                  _Title2['default'],
	                  { level: 2 },
	                  'Enforcement'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'Instances of abusive, harassing, or otherwise unacceptable behavior may be reported to the community leaders responsible for enforcement at ',
	                  _react2['default'].createElement(
	                    _Link2['default'],
	                    {
	                      href: 'mailto:opensource-conduct@airbnb.com'
	                    },
	                    'opensource-conduct@airbnb.com'
	                  ),
	                  '. All complaints will be reviewed and investigated promptly and fairly.'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'All community leaders are obligated to respect the privacy and security of the reporter of any incident.'
	                )
	              ),
	              _react2['default'].createElement(
	                _HeadingSection2['default'],
	                null,
	                _react2['default'].createElement(
	                  _Title2['default'],
	                  { level: 2 },
	                  'Enforcement Guidelines'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'Community leaders will follow these Community Impact Guidelines in determining the consequences for any action they deem in violation of this Code of Conduct:'
	                ),
	                _react2['default'].createElement(
	                  _HeadingSection2['default'],
	                  null,
	                  _react2['default'].createElement(
	                    _Title2['default'],
	                    { level: 3 },
	                    '1. Correction'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Community Impact: Use of inappropriate language or other behavior deemed unprofessional or unwelcome in the community.'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Consequence: A private, written warning from community leaders, providing clarity around the nature of the violation and an explanation of why the behavior was inappropriate. A public apology may be requested.'
	                  )
	                ),
	                _react2['default'].createElement(
	                  _HeadingSection2['default'],
	                  null,
	                  _react2['default'].createElement(
	                    _Title2['default'],
	                    { level: 3 },
	                    '2. Warning'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Community Impact: A violation through a single incident or series of actions.'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Consequence: A warning with consequences for continued behavior. No interaction with the people involved, including unsolicited interaction with those enforcing the Code of Conduct, for a specified period of time. This includes avoiding interactions in community spaces as well as external channels like social media. Violating these terms may lead to a temporary or permanent ban.'
	                  )
	                ),
	                _react2['default'].createElement(
	                  _HeadingSection2['default'],
	                  null,
	                  _react2['default'].createElement(
	                    _Title2['default'],
	                    { level: 3 },
	                    '3. Temporary Ban'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Community Impact: A serious violation of community standards, including sustained inappropriate behavior.'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Consequence: A temporary ban from any sort of interaction or public communication with the community for a specified period of time. No public or private interaction with the people involved, including unsolicited interaction with those enforcing the Code of Conduct, is allowed during this period. Violating these terms may lead to a permanent ban.'
	                  )
	                ),
	                _react2['default'].createElement(
	                  _HeadingSection2['default'],
	                  null,
	                  _react2['default'].createElement(
	                    _Title2['default'],
	                    { level: 3 },
	                    '4. Permanent Ban'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Community Impact: Demonstrating a pattern of violation of community standards, including sustained inappropriate behavior, harassment of an individual, or aggression toward or disparagement of classes of individuals.'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Consequence: A permanent ban from any sort of public interaction within the community.'
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                _HeadingSection2['default'],
	                null,
	                _react2['default'].createElement(
	                  _Title2['default'],
	                  { level: 2 },
	                  'Attribution'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'This Code of Conduct is adapted from the Contributor Covenant, version 2.0, available at',
	                  ' ',
	                  _react2['default'].createElement(
	                    _Link2['default'],
	                    {
	                      href: 'https://www.contributor-covenant.org/version/2/0/code_of_conduct.html'
	                    },
	                    'https://www.contributor-covenant.org/version/2/0/code_of_conduct.html'
	                  ),
	                  '.'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'Community Impact Guidelines were inspired by Mozilla\u2019s code of conduct enforcement ladder.'
	                ),
	                _react2['default'].createElement(
	                  'p',
	                  null,
	                  'For answers to common questions about this code of conduct, see the FAQ at',
	                  ' ',
	                  _react2['default'].createElement(
	                    _Link2['default'],
	                    { href: 'https://www.contributor-covenant.org/faq' },
	                    'https://www.contributor-covenant.org/faq'
	                  ),
	                  '. Translations are available at',
	                  ' ',
	                  _react2['default'].createElement(
	                    _Link2['default'],
	                    {
	                      href: 'https://www.contributor-covenant.org/translations'
	                    },
	                    'https://www.contributor-covenant.org/translations.'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	
	    return render;
	  }();
	
	  return CodeOfConductPage;
	}(_react2['default'].PureComponent);
	
	exports['default'] = CodeOfConductPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-codeofconduct-index-jsx-a15e27898fe7c538d64d.js